import L from 'leaflet';
import pin from './pin';
import * as styles from './styles';

enum GeofenceType {
  BASE = 'BASE',
  CLIENT = 'CLIENT',
  OTHER = 'OTHER',
  HEADQUARTER = 'HEADQUARTER',
  SUPPLY = 'SUPPLY',
  MAINTENANCE = 'MAINTENANCE',
  STATE = 'STATE',
  CITY = 'CITY',
  PATH = 'PATH',
  DEFAULT = 'DEFAULT', // Fallback
}

const GeofenceIcon = (type: GeofenceType) => {
  return new L.DivIcon({
    html: `
      <div class="${styles.pinContainer(type)}">
        ${pin}
      </div>
    `,
  });
};

export default GeofenceIcon;
